module.exports = __webpack_public_path__ + "img/6.3969de45.png";